import { render } from "./recomendation-vue.vue?vue&type=template&id=9a2ff224&scoped=true"
import script from "./recomendation-vue.vue?vue&type=script&lang=js"
export * from "./recomendation-vue.vue?vue&type=script&lang=js"

import "./recomendation-vue.vue?vue&type=style&index=0&id=9a2ff224&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2ff224"]])

export default __exports__